import { API_CLIENT } from "../api_call/service_instances.js";

import {
  GET_PARKING_STREETS,
  GET_STREET_LOAD,
  GET_PARKING_STREET_TO_PAY,
  GET_PARKING_NO_STREET
} from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for parking part
 * --------------------------------------------------------
 */

export default {
  // ToDo fix this
  // Return Error By Default
  // because the tirana parking is separate by the tirana
  // mobility
  getParkingStreets() {
    return API_CLIENT(GET_PARKING_STREETS);
  },

  getStreetLoad() {
    return API_CLIENT(GET_STREET_LOAD);
  },

  getParkingStreetsToPay() {
    return API_CLIENT(GET_PARKING_STREET_TO_PAY);
  },

  getParkingNoStreet() {
    return API_CLIENT(GET_PARKING_NO_STREET);
  }
};
